import React from "react";
import { ElementContainer } from "../../containers/styledComponents";
import {
  compassLightGreen,
  darkGreen,
  greyText,
  lightGreyOutline,
} from "../../../styles";
import { Icon, IconContainer } from "../styledComponents";
import { CompassParagraph } from "../../common/styledComponents";
import lockIcon from "../../../assets/svg/lock.svg";
import { TabElement } from "./TabOptions";

export const TabOption = ({
  tabElement,
  isActive,
  handleTabElementChange,
}: TabOptionProps): JSX.Element => {
  return (
    <ElementContainer
      ai="center"
      mt={-1}
      mr={-1}
      cursor="pointer"
      bb={`1px solid ${isActive ? compassLightGreen : lightGreyOutline}`}
      onMouseEnter={(): void =>
        handleTabElementChange(tabElement.title, TabAction.HOVER_ENTER)
      }
      onMouseLeave={(): void =>
        handleTabElementChange(tabElement.title, TabAction.HOVER_LEAVE)
      }
      onClick={(): void =>
        handleTabElementChange(tabElement.title, TabAction.CLICK)
      }
    >
      <IconContainer>
        <Icon src={isActive ? tabElement.activeIcon : tabElement.icon} />
      </IconContainer>
      <CompassParagraph
        mr={tabElement.isLocked ? 1 : 10}
        color={isActive ? darkGreen : greyText}
        cursor="pointer"
      >
        {tabElement.title}
      </CompassParagraph>
      {tabElement.isLocked && (
        <IconContainer size={25} m={1}>
          <Icon src={lockIcon} />
        </IconContainer>
      )}
    </ElementContainer>
  );
};

type TabOptionProps = {
  tabElement: TabElement;
  isActive: boolean;
  handleTabElementChange: (title: string, action: TabAction) => void;
};

export enum TabAction {
  HOVER_ENTER = "hoverEnter",
  HOVER_LEAVE = "hoverLeave",
  CLICK = "click",
}
